import React, {useCallback, useState} from 'react';
import {Navigate, useLocation, useParams} from 'react-router-dom';

import Questionnaire from './Questionnaire';
import ErrorMessage from "./ErrorMessage";
import Question from "./Question";
import {LanguageProvider} from "./LanguageProvider";
import {client} from "../../apollo/client";
import {GET_ASSESSMENT_OPTIONS, GET_ASSESSMENT_OPTIONS_AND_WELCOME_MESSAGE, NEW_ASSESSMENT} from "../../apollo/queries";
import useAsyncResult from "../hooks/useAsyncResult";
import {useMutation} from "@apollo/client";
import {parseQuery} from "../logic/utils";
import QuestionSubmitButton from "./QuestionSubmitButton";

const Endpoint = () => {
  const { institution, assessmentType, language } = useParams()
  const { inviteUuid } = parseQuery(window.location.search);
  const [assessmentUuid, setAssessmentUuid] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const loading = false;
  const assessmentRoute = `${institution}/${assessmentType}`;

  const [newAssessment] = useMutation(NEW_ASSESSMENT, {
    onCompleted: (data) => {
      setAssessmentUuid(data.newAssessment.externalUuid)
    }
  })

  const fetchEndpoint = useCallback(async() => {
    try {
      const result = await client.query({
        query: GET_ASSESSMENT_OPTIONS_AND_WELCOME_MESSAGE,
        variables: {
          route: assessmentRoute,
          languageCode: language ?? null
        }
      });
      return result.data.assessmentOptionsAndWelcomeMessageByRoute
    } catch(err) {
      console.log(`Cannot find options and welcome text with given route '${assessmentRoute}' and language '${language}'`)
      throw err
    }

  }, [institution])

  const { error, result: endpointOptions} = useAsyncResult(fetchEndpoint);

  if (assessmentUuid) {
    console.log(`/assessments/assessment/${assessmentUuid}/1`)
    return (
      <>
        <Navigate to={`/assessments/assessment/${assessmentUuid}/1`} />
        {/*<Navigate push to={`/assessments/assessment/${assessmentUuid}/2`} />*/}
      </>
    );
  }

  let content;
  let endpoint;

  if (endpointOptions) {
    console.log(endpointOptions)
    const {welcomeMessage, instituteLogo} = endpointOptions
    endpoint = {
      welcome: {
        button: 'Start',
        description: welcomeMessage.welcomeDescription,
        text: {
          nl:`<p align="center">
        <img src="${instituteLogo}" style="width: 100%; max-width: 400px">
        </p>${welcomeMessage.welcomeText}`,
        },
        type: 'QuestionTypeIntermezzo',
        key: 'welcome'
      },
      language: language ? language.toUpperCase() : 'NL'
    };

    const onStart = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      await newAssessment({
        variables: {
          input: {
            assessmentRoute,
            language,
            inviteUuid
          }
        },
      });
    };

    content = <form onSubmit={onStart} style={{margin: 'auto', marginTop: "20px", marginBottom: "20px"}} className={'box'}>
        <Question data={endpoint.welcome} className={'box'} />
        <QuestionSubmitButton caption={endpoint.welcome.button} loading={isSubmitting} ref={(node) => {
          if (node) {
            node.style.setProperty("margin-left", "-22px", "important");
            node.style.setProperty("padding-right", "62px", "important");
          }
        }}
        />
      </form>;
  } else if (error) {
    console.log("within error message")
    content = <ErrorMessage error={'Error retrieving assessment'} />;
  }

  return (
    <LanguageProvider language={endpoint && endpoint.language}>
      {endpointOptions && endpointOptions.options &&
        <Questionnaire
          title={endpointOptions.options.assessmentTitle}
          colorPrimary={endpointOptions.options.assessmentColorPrimary}
          colorSecondary={endpointOptions.options.assessmentColorSecondary}
        >
          {content}
        </Questionnaire>
      }
      {error &&
          <Questionnaire
              title={endpointOptions?.options?.assessmentTitle}
              colorPrimary={endpointOptions?.options?.assessmentColorPrimary}
              colorSecondary={endpointOptions?.options?.assessmentColorSecondary}
          >
            {content}
          </Questionnaire>
      }
    </LanguageProvider>
  );
};

export default Endpoint;
